import { RemoteCitizenCategoriesCoefficientsService } from '@prodcard/core-web-app'
import { httpClient } from './remote'

const citizenCategoriesCoefficientsService = new RemoteCitizenCategoriesCoefficientsService(httpClient)

export { citizenCategoriesCoefficientsService }
